export default {
  all: [],
  current: null
}
